import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NoBankAccountsAlert = ({ clientId, show }) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      {t('CONTRACT_VIEW.CONTRACT_DETAIL.NO_BANK_ACCOUNTS_FOR_AUTOMATIC_DEBIT')}
      {clientId && (
        <>
          {' '}
          <Link
            to={`/clients/detail/${clientId}/billing/bank_account`}
          >
            {t('CONTRACT_VIEW.CONTRACT_DETAIL.GO_TO_BANK_ACCOUNTS')}
          </Link>
        </>
      )}
    </Alert>
  );
};

NoBankAccountsAlert.propTypes = {
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  show: PropTypes.bool.isRequired
};

export default NoBankAccountsAlert;

